import { filterWidgetsByLicense } from 'store/dashboardSlice'
import { useAppSelector } from 'store/hooks'
import {
	hideDigitizationUi,
	isDigitizationWidgetType,
} from 'utils/companyDigitizationFeatures'
import {
	isMilkYieldWidgetType,
	showMilkYieldUi,
} from 'utils/companyMilkFeatures'

import type { DockCategoryKey } from '../components/dock-container/utils/widgetsByCategory'
import {
	DOCK_SECTIONS,
	WIDGETS_BY_CATEGORY,
} from '../components/dock-container/utils/widgetsByCategory'

const isWidgetHiddenForCompany = (
	type: string,
	companyId?: number | null,
): boolean =>
	(!showMilkYieldUi(companyId) && isMilkYieldWidgetType(type)) ||
	(hideDigitizationUi(companyId) && isDigitizationWidgetType(type))

export const useLicensedWidgets = (category: DockCategoryKey) => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { userData } = useAppSelector(state => state.userReducer)
	const widgets = filterWidgetsByLicense(
		WIDGETS_BY_CATEGORY[category],
		permissions,
	)
	const companyId = userData?.company?.id

	return widgets.filter(
		widget => !isWidgetHiddenForCompany(widget.type, companyId),
	)
}

export const useHasLicensedWidgets = (category: DockCategoryKey) =>
	useLicensedWidgets(category).length > 0

/** Returns sections that have at least one licensed widget. */
export const useLicensedSections = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { userData } = useAppSelector(state => state.userReducer)
	const companyId = userData?.company?.id

	return DOCK_SECTIONS.filter(({ key }) => {
		const widgets = filterWidgetsByLicense(
			WIDGETS_BY_CATEGORY[key],
			permissions,
		).filter(widget => !isWidgetHiddenForCompany(widget.type, companyId))

		return widgets.length > 0
	})
}
